import { Input } from '../../../../Input';
import { FieldTypeInnCompany } from './types';

export const getValidationInputType = (type: FieldTypeInnCompany) => {
  return type === 'inn'
    ? {
        inputType: 'number' as const,
        validationType: Input.validations.Inn,
      }
    : {
        inputType: 'text' as const,
        validationType: Input.validations.Company,
      };
};
